import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ClockArrowPlusIcon = (props: IconProps) => (
  <Icon w="54px" h="54px" viewBox="0 0 54 54" {...props}>
    <path d="M10.4966 25.875C11.4641 32.6475 16.7747 38.0704 23.5022 39.1729L26.2246 43.875H26.0664C15.6489 43.875 7.07544 36 5.95044 25.875H10.4966Z" />
    <path d="M28.3164 12.375V22.7021L31.4673 25.8311L29.1272 29.8564L23.8164 24.5479V12.375H28.3164Z" />
    <path d="M26.0664 3.375C37.2489 3.375 46.3164 12.4425 46.3164 23.625H41.8164C41.8164 14.94 34.7514 7.875 26.0664 7.875C20.7339 7.875 16.0084 10.5525 13.1509 14.625H19.3164V19.125H5.81641V5.625H10.3164V10.9358C14.0289 6.34579 19.6989 3.375 26.0664 3.375Z" />
    <path d="M44.1562 36.8438H51.75V41.9062H44.1562V49.5H39.0938V41.9062H31.5V36.8438H39.0938V29.25H44.1562V36.8438Z" />
  </Icon>
);

export default memo(ClockArrowPlusIcon);
